import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

// French count + noun: 0 and 1 take the singular ("1 master", "0 projet"), 2+ the plural
export function plural(count, singular, pluralForm = `${singular}s`) {
    return `${count} ${count > 1 ? pluralForm : singular}`;
}
